export default __webpack_public_path__ + "static/media/Pirate_Fest_Flyer.02ed36c3.jpg";